import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableFooter from "@material-ui/core/TableFooter";
import Typography from "@material-ui/core/Typography";
import LeftIcon from "@material-ui/icons/ChevronLeft";
import RightIcon from "@material-ui/icons/ChevronRight";
import React from "react";
import { LoggerFactory } from "../../logger";
import { DataTableProps, styles } from "./commons";
import { FirstPage, LastPage } from "@material-ui/icons";
import { withStyles } from "@material-ui/core";

class DataTableFooterComponent extends React.Component<DataTableProps> {
  private readonly log = LoggerFactory.create("DataTableFooter");

  public render() {
    const currentPage = this.currentPage();
    const pageSize = this.currentPageSize();
    const isLastPage = pageSize * (currentPage + 1) >= this.props.total;
    const pageSizeOptions = this.props.pageSizeOptions || [25, 50, 100];
    const rowsPerPageSelectorTitle = this.props.i18n.t(
      "lego:views.index.footer.rowsPerPageSelectorTitle",
      "Rows per page"
    );
    const totalTitle = this.props.i18n.t(
      "lego:views.index.footer.total",
      "Total"
    );

    return (
      <TableFooter className={this.props.classes.footer} component="div">
        {!this.props.hidePageable && (
          <>
            <Typography color="textSecondary">
              {rowsPerPageSelectorTitle}
            </Typography>
            <Select
              value={pageSize}
              onChange={this.handleChangeRowsPerPage}
              variant="filled"
              classes={{ root: this.props.classes.footerContentPageSizeRoot }}
              className={this.props.classes.footerContentPageSizeSelector}
            >
              {pageSizeOptions.map((val: number) => (
                <MenuItem key={val + "rpp"} value={val}>
                  {val}
                </MenuItem>
              ))}
            </Select>
            <IconButton
              onClick={this.goToFirstPage}
              size={"small"}
              disabled={currentPage === 0}
            >
              <FirstPage />
            </IconButton>
            <IconButton
              onClick={this.goToPrevPage}
              size={"small"}
              disabled={currentPage === 0}
            >
              <LeftIcon />
            </IconButton>
            <Typography color="textSecondary">
              {`${currentPage + 1} of ${this.lastPage() + 1 || "1"}`}
            </Typography>
            <IconButton
              onClick={this.goToNextPage}
              size={"small"}
              disabled={isLastPage}
            >
              <RightIcon />
            </IconButton>
            <IconButton
              onClick={this.goToLastPage}
              size={"small"}
              disabled={isLastPage}
            >
              <LastPage />
            </IconButton>
          </>
        )}
        {!this.props.hideTotalPages && (
          <Typography
            color="textSecondary"
            className={this.props.classes.footerContentTotalPages}
          >
            {totalTitle}: {this.props.total || "0"}
          </Typography>
        )}
      </TableFooter>
    );
  }

  public currentPage = () => {
    const { page } = this.props.params;
    return page && page.pageNumber;
  };

  public currentPageSize = () => {
    const { page } = this.props.params;
    return page && page.pageSize;
  };

  public lastPage = () => {
    const { params } = this.props;
    return Math.max(0, Math.ceil(this.props.total / params.page.pageSize) - 1);
  };

  public goToFirstPage = () => {
    this.changePage(0);
  };

  public goToPrevPage = () => {
    this.changePage(this.currentPage() - 1);
  };

  public goToNextPage = () => {
    this.changePage(this.currentPage() + 1);
  };

  public goToLastPage = () => {
    this.changePage(this.lastPage());
  };

  private changePage = (destination: number) => {
    const { params } = this.props;
    this.props.search({
      ...params,
      page: {
        pageNumber: destination,
        pageSize: params.page.pageSize
      }
    });
  };

  public handleChangeRowsPerPage = (e: any) => {
    this.log.debug("handleChangeRowsPerPage", e);
    const { params } = this.props;

    this.props.search({
      ...params,
      page: { pageNumber: 0, pageSize: e.target.value }
    });
  };
}

export const DataTableFooter = withStyles(styles, { withTheme: true })(
  DataTableFooterComponent
);
